import React from "react";
import PropTypes from "prop-types";

const Heading = ({ className, text, id, level }) => {
  switch (level) {
    case 1:
      return (
        <h1 className={`font--subhead font-light white dib ${className}`}>
          {text}
        </h1>
      );
    case 2:
      return (
        <h2
          className={`font--subhead mw-md font-light white inline ${className}`}
        >
          {text}
        </h2>
      );
    case 3:
      return (
        <h3
          id={id}
          className={`font--headline font-md3 pb-sm pt-lg ${className}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    case 4:
      return (
        <h4
          id={id}
          className={`font-md pb-xs ${className}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    case 5:
      return (
        <h5
          id={id}
          className={`font-xs pb-sm ${className}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    case 6:
      return (
        <h6
          className={`font-xxs pb-xs ${className}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    case 7:
      return (
        <h7
          className={`pb-sm ${className}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    default:
      return (
        <h3
          className={`font--headline font-md3 pb-sm pt-lg ${className}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
  }
};

Heading.propTypes = {
  level: PropTypes.number,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Heading.defaultProps = {
  level: 3,
  className: "",
};

export default Heading;
